import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Website.css";
import axios from 'axios';
import { API_URL } from '../../constants/api';
import './header.css'

function Header() {
  const [logo, setLogo] = useState([]);

  useEffect(() => {
    const get_company = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/users/get-company/user-login`);
        setLogo(response.data.company[0]?.['logo']);
      } catch (e) {
        console.error(e);
      }
    }
    get_company();
  }, []);

  return (
    <header className="header">
      <div className="header-top-bar">
        <div className="e-learning-logo">
          <img src={`${API_URL}/${logo}`} alt="University Logo" className="uni-logo" />
          <span>E-LEARNING</span>
        </div>

        <nav className="header-nav">
          <Link to="/elearningHome" className="nav-link">HOME</Link>
          <Link to="/about" className="nav-link">ABOUT US</Link>

          <details className="dropdown">
            <summary className="nav-link">ACADEMICS ▼</summary>
            <div className="dropdown-content">
              <Link to="/programs" className="dropdown-item">Programs</Link>
              <Link to="/admssionRequirement" className="dropdown-item">Admission Requirements</Link>
            </div>
          </details>

          <Link to="/contact" className="nav-link">CONTACT</Link>
        </nav>

        <button className="login-btn">
          <Link to="/login/student-login" className="nav-link">
            Login <span className="lock-icon">🔒</span>
          </Link>
        </button>
      </div>
    </header>
  );
}

export default Header;
